import * as React from 'react';
import classnames from 'classnames';

import styles from './pagination-dots.less';

interface PaginationDotsProps {
    className?: string;
    dots: number;
    index: number;
    onChangeIndex: (index: number) => void;
    small?: boolean;
}

export const PaginationDots: React.FC<PaginationDotsProps> = ({
    className,
    dots,
    index,
    onChangeIndex,
    small,
}) => {
    const children = [];

    for (let i = 0; i < dots; i += 1) {
        children.push(
            <PaginationDot
                key={i}
                index={i}
                active={i === index}
                onClick={onChangeIndex}
                small={small}
            />
        );
    }

    return <div className={classnames(styles.pagination, className)}>{children}</div>;
};

interface PaginationDotProps {
    index: number;
    active: boolean;
    onClick: (index: number) => void;
    small?: boolean;
}

class PaginationDot extends React.PureComponent<PaginationDotProps> {
    handleClick = () => {
        this.props.onClick(this.props.index);
    };

    render() {
        return (
            <button className={styles.dotWrapper} onClick={this.handleClick}>
                <div
                    className={classnames(styles.dot, {
                        [styles.active]: this.props.active,
                        [styles.smalldot]: this.props.small,
                    })}
                />
            </button>
        );
    }
}
